import Wysiwyg from './wysiwyg.js' 
import Hero from './hero.js'
import Divider from './layout/divider'
import Block from './block.js'
import FrontHero from './front_hero.js'
import HomeHero from './home_hero.js'
import LogoCarousel from './logo_carousel.js'
import Title from './basic/title.js'
import Button from './basic/button.js'
import ProductSlider from './product_slider.js'
import ResourcesCarousel from './resources_carousel.js'
import NewsCarousel from './news_carousel.js'
import BiopharmaCarousel from './biopharma_carousel.js'
import IntroContent from './intro_content.js'
import CallToAction from './call_to_action.js'
import CallToActionCard from './call_to_action_card.js'
import VideoPopUp from './video_pop_up.js'
import Media from './basic/media.js'
import Image from './basic/image.js'
import Video from './basic/video.js'
import FeaturesListing from './features_listing.js'
import Accordion from './accordion.js'
import TeamGrid from './team_grid.js'
import ProductGrid from './product_grid.js'
import Menu from './menu.js'
import Subnavigation from './subnavigation.js'
import Sidebar from './sidebar.js'
import Infographic from './infographic.js'
import InfographicGrid from './infographic_grid.js'
import ExpandableInfographic from './expandable_infographic.js'
import Decoration from './decoration.js'
import Search from './search.js'
import ResourcesSearch from './resources_search.js'
import ListingContent from './listing_content.js'
import LogoListing from './logo_listing.js'
import BlogPost from './blog/blog_post.js'
import BlogCarousel from './blog/blog_carousel.js'
import Event from './post/event.js'
import NewEvent from './post/new_event.js'
import EventCarousel from './post/event_carousel.js'
import Brochure from './asset/brochure.js'
import Poster from './asset/poster.js'
import ProcessAccordion from './process_accordion.js'
import ProcessIcons from './process_icons.js'
import StatisticsSlider from './statistics_slider.js'
import StatisticGrid from './statistic_grid.js'
import DataSheet from './asset/data_sheet.js'
import InfographicAsset from './asset/infographic.js'
import Article from './asset/article.js'
import VideoAsset from './asset/video.js'
import Podcast from './asset/podcast.js'
import Whitepaper from './asset/whitepaper.js'
import Form from './form.js'
import Table from './basic/table.js'
import TabbedContent from './tabbed_content.js'
import IconCardGrid from './icon_card_grid.js'
import IconCards from './icon_cards.js'
import Stat from './stat.js'
import PageNotFound from './404.js'
import MediaAndContent from './media_and_content.js'
import TestimonialSlider from './testimonial_slider.js'
import IconRow from './icon_row.js'
import FourUpIcons from './four_up_icons.js'
import PresentationListing from './presentation_listing.js'
import IcdCodesDirectory from './icd_codes_directory.js'
import ScrollingInfographic from './scrolling_infographic.js'
import ContentAndButton from './content_and_button.js'
import ButtonGroup from './button_group.js'
import StatisticCards from './statistic_cards.js'
import ToggleSections from './toggle_sections.js'
import TestimonialForm from './testimonial_form.js'
import JuicerEmbed from './juicer_embed.js'
import IconButton from './icon_button.js'

export default {
	wysiwyg: Wysiwyg,
	hero: Hero,
	divider: Divider,
	block: Block,
	front_hero: FrontHero,
	home_hero: HomeHero,
	logo_carousel: LogoCarousel,
	title: Title,
	button: Button,
	product_slider: ProductSlider,
	resources_carousel: ResourcesCarousel,
	news_carousel: NewsCarousel,
	biopharma_carousel: BiopharmaCarousel,
	intro_content: IntroContent,
	call_to_action: CallToAction,
	call_to_action_card: CallToActionCard,
	video_pop_up: VideoPopUp,
	media: Media,
	image: Image,
	video: Video,
	features_listing: FeaturesListing,
	accordion: Accordion,
	team_grid: TeamGrid,
	product_grid: ProductGrid,
	menu: Menu,
	subnavigation: Subnavigation,
	sidebar: Sidebar,
	infographic: Infographic,
	infographic_grid: InfographicGrid,
	expandable_infographic: ExpandableInfographic,
	decoration: Decoration,
	search: Search,
	resources_search: ResourcesSearch,
	listing_content: ListingContent,
	logo_listing: LogoListing,
	blog_post: BlogPost,
	blog_carousel: BlogCarousel,
	event : Event,
	new_event: NewEvent,
	event_carousel: EventCarousel,
	brochure: Brochure,
	poster: Poster,
	process_accordion: ProcessAccordion,
	process_icons: ProcessIcons,
	statistics_slider: StatisticsSlider,
	statistic_grid: StatisticGrid,
	data_sheet: DataSheet,
	infographic_asset: InfographicAsset,
	article : Article,
	video_asset : VideoAsset,
	podcast : Podcast,
	whitepaper : Whitepaper,
	form: Form,
	table: Table,
	tabbed_content: TabbedContent,
	icon_card_grid: IconCardGrid,
	icon_cards: IconCards,
	stat: Stat,
	404: PageNotFound,
	media_and_content: MediaAndContent,
	testimonial_slider: TestimonialSlider,
	icon_row: IconRow,
	four_up_icons: FourUpIcons,
	presentation_listing: PresentationListing,
	icd_codes_directory: IcdCodesDirectory,
	scrolling_infographic: ScrollingInfographic,
	content_and_button: ContentAndButton,
	button_group: ButtonGroup,
	statistic_cards: StatisticCards,
	toggle_sections: ToggleSections,
	testimonial_form: TestimonialForm,
	juicer_embed: JuicerEmbed,
	icon_button: IconButton
}